import React from 'react';
import { useTranslation } from 'react-i18next';
import {connect} from "react-redux";
import PicButton from "../../../../../../../../../../../../../../../components/pic-button";
import Icon from "../../../../../../../../../../../../../../../components/icon";
import './index.css';

function MoreOptions (props) {

    const {
        clickHandler,
        mouseLeaveHandler,
        extendDropDown,
        editCommentHandler,
        deleteCommentHandler
    } = props;
    const { t } = useTranslation();

    return (
        <PicButton className="more-options-btn d-flex align-items-center" onClick={clickHandler}>
            <Icon name="ellipsis-v"/>
            {
                extendDropDown
                    ?
                    <ul className="more-options" onMouseLeave={mouseLeaveHandler}>
                        <li onClick={editCommentHandler}><Icon name="pencil"/> {t("textEditMessage")}</li>
                        <li onClick={deleteCommentHandler}><Icon name="trash"/> {t("Delete")}</li>
                    </ul>
                    :
                    null
            }
        </PicButton>
    )
}

const mapStateToProps = (state) => ({
    sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
    selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
});

export default connect(mapStateToProps)(MoreOptions);
